import React, { useState, useEffect } from 'react'
import emailjs from '@emailjs/browser';
import Nav from './Nav'
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner'
import { menuItems, emailJSInit } from '../helpers/variables';

export default function Menu() {

    useEffect(() => emailjs.init(emailJSInit), [])

    function handleShowModal() {
        setModalIsVisible(true)
    }
    function handleClose() {
        setModalIsVisible(false)
    }

    function handleCloseSuccess() { setIsSuccessful(false) }
    function handleSubmit(event) {
        event.preventDefault()
        setIsWaiting(true)

        const formData = {
            name: event.target[1].value,
            email: event.target[2].value,
            message: `The person above is requesting the following bulk order: \n
             ${event.target[3].value} \n

             On the following pickup date: \n
             ${event.target[4].value}
            `
        }

        emailjs.send('service_03oqynp', 'template_21lpl62', formData)
            .then(
                () => {
                    setModalIsVisible(false);
                    setIsWaiting(false)
                },
                (error) => { console.log('FAILED...', error); }
            )
            .then(() => {
                setIsSuccessful(true);
            }
            )
    }

    const [modalIsVisible, setModalIsVisible] = useState(false)
    const [isWaiting, setIsWaiting] = useState(false)
    const [isSuccessful, setIsSuccessful] = useState(false)

    return (
        <div className="page-content">
            <Nav />
            <main className='menu-page'>
                <div className="menu-content py-4">
                    <section >
                        <h1>Bulk Order Menu</h1>
                        <p>Submit the <button className='unstyled-button' onClick={handleShowModal}>contact form</button> to request a bulk or "party-size" order of any of the following items. If you want an "off-menu" item, please use my <a href="about">general contact form</a>.</p>
                    </section>
                </div>
                <div className='d-flex flex-wrap gap-4 pb-4 menu-items'>
                    {menuItems.map((item) => {
                        return (
                            <Card key={item.itemName} style={{ width: '13rem' }}>
                                <Card.Img variant="top" src={require(`../images/${item.itemImage}`)} />
                                <Card.Body>
                                    <Card.Title>{item.itemName}</Card.Title>
                                    <Card.Text>
                                        {item.itemText}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        )
                    })
                    }
                </div>
                <Modal
                    show={modalIsVisible}
                    onHide={handleClose}
                >
                    <Form onSubmit={handleSubmit}>
                        <Modal.Header closeButton>
                            <Modal.Title>Bulk Order Request</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form.Group>
                                <Form.Label>Name</Form.Label>
                                <Form.Control type="text" placeholder="Enter name" />
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Item names and quantities requested</Form.Label>
                                <Form.Control as="textarea" rows={3} />
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Pickup date requested*</Form.Label>
                                <Form.Control type="date" />
                                *Actual pickup date depends on availability. I will contact you to schedule.
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant='secondary' onClick={handleClose}>Close</Button>
                            {isWaiting ? <button className='primary-button' type="submit">
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                /> Sending...</button> :
                                <button className='primary-button' type="submit">Submit Order</button>}
                        </Modal.Footer>
                    </Form>
                </Modal>
                <Modal show={isSuccessful} onHide={handleCloseSuccess}>
                    <Modal.Header closeButton>
                        <Modal.Title>Order Submitted</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Your order has been sent. Please <a href='about'>contact me</a> if you have any questions.</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseSuccess}>
                            Close
                        </Button>
                    </Modal.Footer>
                </Modal>
            </main>

        </div>
    )
}